var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0028 5.00019H3.41283L6.71283 1.71019C6.90113 1.52188 7.00692 1.26649 7.00692 1.00019C7.00692 0.733884 6.90113 0.478489 6.71283 0.290185C6.52452 0.101882 6.26913 -0.00390625 6.00283 -0.00390625C5.73652 -0.00390625 5.48113 0.101882 5.29283 0.290185L0.292826 5.29019C0.201785 5.38529 0.13042 5.49743 0.082826 5.62019C-0.017192 5.86365 -0.017192 6.13672 0.082826 6.38019C0.13042 6.50294 0.201785 6.61508 0.292826 6.71019L5.29283 11.7102C5.38579 11.8039 5.49639 11.8783 5.61825 11.9291C5.74011 11.9798 5.87081 12.006 6.00283 12.006C6.13484 12.006 6.26554 11.9798 6.3874 11.9291C6.50926 11.8783 6.61986 11.8039 6.71283 11.7102C6.80655 11.6172 6.88095 11.5066 6.93172 11.3848C6.98249 11.2629 7.00862 11.1322 7.00862 11.0002C7.00862 10.8682 6.98249 10.7375 6.93172 10.6156C6.88095 10.4937 6.80655 10.3831 6.71283 10.2902L3.41283 7.00019H11.0028C11.268 7.00019 11.5224 6.89483 11.7099 6.70729C11.8975 6.51976 12.0028 6.2654 12.0028 6.00019C12.0028 5.73497 11.8975 5.48062 11.7099 5.29308C11.5224 5.10554 11.268 5.00019 11.0028 5.00019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackMobile);
export default __webpack_public_path__ + "static/media/back_mobile.9b2e1273dbaea9cb516f13a8a8e42670.svg";
export { ForwardRef as ReactComponent };